import React, { useEffect, useState } from 'react';
import { Alert } from '../../../ui-kit';
import styled from 'styled-components';
import SettingsForm from '../ui-kit/SettingsForm';

const ZoomableIFrame = styled.iframe`
  -ms-transform: scale(${props => props.zoomRate});
  -moz-transform: scale(${props => props.zoomRate});
  -o-transform: scale(${props => props.zoomRate});
  -webkit-transform: scale(${props => props.zoomRate});
  transform: scale(${props => props.zoomRate});

  -ms-transform-origin: 0 0;
  -moz-transform-origin: 0 0;
  -o-transform-origin: 0 0;
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;
`;

const Settings = ({ updateWidgetSettingsField, widgetSettings }) => (
  <SettingsForm updateWidgetSettingsField={updateWidgetSettingsField} widgetSettings={widgetSettings}>
    <SettingsForm.Section>
      <SettingsForm.Section.Header>{I18n.t('general')}</SettingsForm.Section.Header>
      <SettingsForm.Section.Content>
        <Alert variant="warning">
          {I18n.t('dashboards.widget_archetypes.iframe.settings.x_frame_options_warning')}
        </Alert>
        <SettingsForm.InputField
          labelColWidth={4}
          fieldName="url"
          label={I18n.t('dashboards.widget_archetypes.iframe.settings.url')}
        />
        <SettingsForm.InputField
          fieldName="refreshInterval"
          label={I18n.t('dashboards.widget_archetypes.iframe.settings.refresh_interval')}
          type="number"
        />
      </SettingsForm.Section.Content>
    </SettingsForm.Section>
    <hr />
    <SettingsForm.Section>
      <SettingsForm.Section.Header>{I18n.t('display')}</SettingsForm.Section.Header>
      <SettingsForm.Section.Content>
        <SettingsForm.InputField
          fieldName="zoomPercentage"
          label={I18n.t('dashboards.widget_archetypes.iframe.settings.zoom_percentage')}
          type="number"
        />
      </SettingsForm.Section.Content>
    </SettingsForm.Section>
  </SettingsForm>
);

const IframeWidget = ({ url, refreshInterval, zoomPercentage }) => {
  const [refreshedAt, setRefreshedAt] = useState(Date.now());

  const zoomRate = zoomPercentage / 100;

  useEffect(() => {
    // Ensure the refresh interval is at least 10 seconds
    const refreshIntervalMs = Math.max(10, refreshInterval) * 1000;

    const intervalId = setInterval(() => {
      setRefreshedAt(Date.now());
    }, refreshIntervalMs);

    return () => clearInterval(intervalId);
  }, [refreshInterval]);

  return (
    <ZoomableIFrame
      zoomRate={zoomRate}
      key={refreshedAt}
      style={{
        width: `${100 / zoomRate}%`,
        height: `${95 / zoomRate}%`
      }}
      src={url}
    />
  );
};

Object.assign(IframeWidget, {
  SettingsContent: Settings,
  defaultSettings: {
    url: '/',
    refreshInterval: 3600,
    zoomPercentage: 100
  }
});

export default IframeWidget;
